"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
function inputType(props) {
  return props.type || "text";
}
function label(props) {
  if (props.label) {
    return /* @__PURE__ */ jsx("label", { htmlFor: props.id, children: props.label });
  }
}
function divClasses(props) {
  var classes = props.divClasses;
  if (props.errors) {
    classes += " error";
  }
  return classes;
}
function errorMessage(props) {
  var errors;
  if (errors = props.errors) {
    return /* @__PURE__ */ jsx("small", { className: "error", children: errors });
  }
}
function FormInput(props) {
  return /* @__PURE__ */ jsxs("div", { "data-component": "FormInput", className: divClasses(props), children: [
    label(props),
    /* @__PURE__ */ jsx(
      "input",
      {
        type: inputType(props),
        placeholder: props.placeholder,
        onChange: props.onChange,
        onKeyDown: props.onKeyDown,
        value: props.value,
        checked: props.checked,
        id: props.id
      }
    ),
    errorMessage(props)
  ] });
}
export default FormInput;
